module.exports = __webpack_public_path__ + "assets/img/2468.519b862e.png";